module.exports = __webpack_public_path__ + "static/media/dark_payment.e5d296bb.svg";